import { defineMessages } from 'react-intl'

const scope = `procurify.components.CurrencySelect`

export default defineMessages({
  selectPlaceholderText: {
    id: `${scope}.selectPlaceholderText`,
    defaultMessage: 'Select a currency',
  },
})
